import { render } from "./SingleSkuOrderInformation.vue?vue&type=template&id=77afff34&scoped=true"
const script = {}

import "./SingleSkuOrderInformation.vue?vue&type=style&index=0&id=77afff34&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77afff34"]])

export default __exports__